import React, { useState } from 'react';
import api from '../services/api';
import './SuperAdminLogin.css';

function SuperAdminLogin({ onLogin }) {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.login(formData.username.trim(), formData.password);
      if (!data.user?.is_super_admin) {
        api.logout();
        setError('This account is not a super admin.');
        setLoading(false);
        return;
      }
      onLogin(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="super-admin-login">
      <div className="super-admin-login-card">
        <div className="super-admin-login-header">
          <h1>Super Admin Login</h1>
          <p>Restricted access for platform administrators.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <label>
            Username
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="admin or admin@default"
              required
            />
          </label>
          <label>
            Password
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </label>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
